// extracted by mini-css-extract-plugin
export default {"icon":"Header_icon__azzLy"};